import React, { useRef } from "react";
import { Toaster } from "react-hot-toast";
import AddLiquidity from "./AddLiqudity/AddLiquidity";
import MyNFTs from "./MyNFTs/MyNFTs";

const NewLiquidityComponent = (props) => {
	const { setMainActiveSection } = props;
	const myNFTsRef = useRef(null);

	return (
		<div className="w-full">
			<div className="relative max-w-140 mx-auto bg-white dark:bg-darkCardBg rounded-b-3xl mb-6 md:mb-18">
				<div className={"relative w-full"}>
					<div
						className={
							"relative w-full rounded-3xl flex flex-col p-4 pt-0 gap-4"
						}
					>
						<AddLiquidity
							activeSection={1}
							setMainActiveSection={setMainActiveSection}
						/>

						<Toaster />
					</div>
				</div>
			</div>
			<MyNFTs ref={myNFTsRef} />
		</div>
	);
};

export default NewLiquidityComponent;
